import React, { useContext } from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  ModalBody,
  Heading,
  Flex,
  Button,
  Box,
  Stack,
  HStack,
  Text,
  Link
} from '@chakra-ui/react'
import SocialList from './socialList'
import { MainContext } from '../../context'
import { offerRulesTC } from './termsAndConditions'
import { IoMdAlert } from 'react-icons/io'
import { AiFillInfoCircle } from 'react-icons/ai'
import { BiCopy } from 'react-icons/bi'
const SocialMedia = ({
  accentColor,
  isOverlay,
  handleOverlay,
  fontFamily,
  currentSocial,
  currentWeb,
  skin,
  selectedBusiness,
  modalType,
  dictionary,
  offer
}) => {
  const contextService = useContext(MainContext)
  const handleTermsAndConditions = (selectedBusiness) => {
    if (!selectedBusiness && modalType === 'TyC') {
      return offerRulesTC(offer, skin, fontFamily)
    } else {
      return <div />
    }
  }

  const handleSocialList = () => {
    console.log(currentWeb)
    console.log(currentWeb !== undefined)
    if (
      (currentWeb && currentWeb !== '' && currentWeb !== 'https://www.') ||
      (currentSocial && currentSocial.length > 0)
    )
      return (
        <div>
          <Heading
            color={skin === 'FINSUS' ? '#23223F' :'brand.primary'}
            fontSize={['18px', '18px', '18px', '18px']}
            fontFamily={fontFamily}
            fontWeight='500'
            mt='24px'
          >
            Enlaces de interés
          </Heading>
          <SocialList
            fontFamily={fontFamily}
            currentSocial={currentSocial}
            currentWeb={currentWeb}
          />
        </div>
      )
  }

  const openPageNewTab = (url) => {
    window.open(url, '_blank')
  }

  function copyCoupon() {
    // get the container
    const element = document.querySelector('#couponContainer')
    // Create a fake `textarea` and set the contents to the text
    // you want to copy
    const storage = document.createElement('textarea')
    storage.value = 'Clara23'
    element.appendChild(storage)

    // Copy the text in the fake `textarea` and remove the `textarea`
    storage.select()
    storage.setSelectionRange(0, 99999)
    document.execCommand('copy')
    element.removeChild(storage)
  }

  const showModal = (modalType) => {
    switch (modalType) {
      case 'TyC':
        return (
          <Modal
            isCentered
            isOpen={isOverlay}
            onClose={handleOverlay}
            scrollBehavior='inside'
          >
            <ModalOverlay
              bg='white.300'
              backdropFilter={
                skin === '' || skin === 'REWORTH'
                  ? 'saturate(180%) blur(5px)'
                  : skin === 'INVEX'
                  ? 'saturate(80%) blur(1px)'
                  : skin === 'UNIQ' ||
                    skin === 'COPPEL' ||
                    skin === 'LIVERPOOL' ||
                    skin === 'SUBURBIA'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'FINSUS'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'ALBO'
                  ? 'saturate(80%) blur(2px)'
                  : null
              }
            />
            <ModalContent bg='brand.bg' shadow='6px 6px 4px #00000029'>
              <ModalCloseButton />
              <ModalBody
                bgImage={
                  skin === '' || skin === 'REWORTH'
                    ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                    : null
                }
                bgColor={
                  skin === '' || skin === 'REWORTH'
                    ? null
                    : 'brand.modalBackground'
                }
                p='1.5rem 2rem 2rem 2rem'
                borderRadius='8px'
              >
                {handleTermsAndConditions(selectedBusiness)}
                {handleSocialList()}
              </ModalBody>
            </ModalContent>
          </Modal>
        )
      case 'confirmationRedirect':
        return (
          <Modal
            isCentered
            isOpen={isOverlay}
            onClose={handleOverlay}
            scrollBehavior='inside'
          >
            <ModalOverlay
              bg='white.300'
              backdropFilter={
                skin === '' || skin === 'REWORTH'
                  ? 'saturate(180%) blur(5px)'
                  : skin === 'INVEX'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'UNIQ'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'COPPEL'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'CLARA'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'FINSUS'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'LIVERPOOL'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'SUBURBIA'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'ALBO'
                  ? 'saturate(80%) blur(2px)'
                  : null
              }
            />
            <ModalContent bg='brand.bg' shadow='6px 6px 4px #00000029'>
              <ModalCloseButton />
              <ModalBody
                bgImage={
                  skin === '' || skin === 'REWORTH'
                    ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                    : null
                }
                bgColor={
                  skin === '' || skin === 'REWORTH'
                    ? null
                    : 'brand.modalBackground'
                }
                p='1.5rem 2rem 2rem 2rem'
                borderRadius='8px'
              >
                {handleTermsAndConditions(selectedBusiness)}
                <Heading
                  color='brand.primary'
                  fontSize={['18px', '18px', '18px', '18px']}
                  fontFamily={fontFamily}
                  fontWeight='500'
                >
                  <Flex>
                    <IoMdAlert
                      color={skin === 'COPPEL' ? '#F7DD57' : skin === 'ALBO' ? '#F8644F' :accentColor}
                      fontSize='2rem'
                    />
                    <Text fontSize='1.2rem' mx='1'>
                      {dictionary.CARDS.wait}
                    </Text>
                  </Flex>
                </Heading>
                <Box display='flex' p='5'>
                  <Text fontWeight='500'>
                    {dictionary.CARDS.confirmationOutOne}
                    <br />
                    {dictionary.CARDS.confirmationOutTwo}
                  </Text>
                </Box>

                <Box>
                  <HStack bg={skin === 'ALBO' ? '#F7F7F7' :'#F7F7F7'} p='2' borderRadius={skin === 'ALBO' ? '6px': '4px'}>

                    <Text>
                      {`${
                        skin === 'INVEX'
                          ? dictionary.CARDS.redirectTooltipOneInvex
                          : dictionary.CARDS.redirectTooltipOne
                      }
                      ${
                        skin === 'ALBO' || skin === 'FINSUS' ? skin.toLowerCase() :
                        skin.charAt(0).toUpperCase() +
                        skin.slice(1).toLowerCase()
                      }

                      ${dictionary.CARDS.redirectTooltipTwo}`}
                    </Text>
                  </HStack>
                </Box>


                <Stack my={3} justifyContent='space-between' direction='row'>
                  <Button
                    color={skin === 'ALBO' ? '#F8644F' : accentColor}
                    width='50%'
                    border={`2px solid ${accentColor}`}
                    borderColor = {skin === 'ALBO' ? '#F8644F' : accentColor}
                    borderRadius='2px'
                    variant='outline'
                    _hover={{
                      borderColor: skin === 'ALBO' ? '#3743AA' : null,
                      color: skin === 'ALBO' ? '#3743AA' : null,
                      transform: 'scale(1.02)',
                    }}
                    onClick={handleOverlay}
                  >
                    {dictionary.CARDS.cancel}
                  </Button>
                  <Button
                    color='white'
                    width='50%'
                    borderRadius='2px'
                    bg={skin === 'ALBO' ? '#F8644F' : accentColor}
                    _hover={{
                      bg:skin === 'ALBO' ? '#3743AA': null,
                      borderColor: skin === 'ALBO' ? '#3743AA' : null,
                      transform: 'scale(1.02)',
                    }}
                    onClick={() => openPageNewTab(currentWeb)}
                  >
                    {dictionary.CARDS.continue}
                  </Button>
                </Stack>
              </ModalBody>
            </ModalContent>
          </Modal>
        )
      case 'redirectWithCoupon':
        return (
          <Modal
            isCentered
            isOpen={isOverlay}
            onClose={handleOverlay}
            scrollBehavior='inside'
          >
            <ModalOverlay
              bg='white.300'
              backdropFilter={
                skin === '' || skin === 'REWORTH'
                  ? 'saturate(180%) blur(5px)'
                  : skin === 'INVEX'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'UNIQ'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'COPPEL'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'CLARA'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'FINSUS'
                  ? 'saturate(80%) blur(2px)'
                  : skin === 'LIVERPOOL'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'SUBURBIA'
                  ? 'saturate(60%) blur(2px)'
                  : skin === 'ALBO'
                  ? 'saturate(80%) blur(2px)'
                  : null
              }
            />
            <ModalContent bg='brand.bg' shadow='6px 6px 4px #00000029'>
              <ModalCloseButton />
              <ModalBody
                bgImage={
                  skin === '' || skin === 'REWORTH'
                    ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                    : null
                }
                bgColor={
                  skin === '' || skin === 'REWORTH'
                    ? null
                    : 'brand.modalBackground'
                }
                p='1.5rem 2rem 2rem 2rem'
                borderRadius='8px'
              >
                {handleTermsAndConditions(selectedBusiness)}
                <Heading
                  color='brand.primary'
                  fontSize={['18px', '18px', '18px', '18px']}
                  fontFamily={fontFamily}
                  fontWeight='500'
                >
                  <Flex>
                    <IoMdAlert
                      color={skin === 'COPPEL' ? '#F7DD57' : accentColor}
                      fontSize='2rem'
                    />
                    <Text fontSize='1.2rem' mx='1'>
                      {dictionary.CARDS.wait}
                    </Text>
                  </Flex>
                </Heading>
                <Box display='flex' p='5'>
                  <Text fontWeight='500'>
                    {dictionary.CARDS.confirmationOutOne}
                    <br />
                    {dictionary.CARDS.confirmationOutTwo}
                  </Text>
                </Box>
                <Box>
                  <Stack
                    direction='row'
                    display='flex'
                    p='5'
                    textAlign='center'
                  >
                    <Box
                      id='couponContainer'
                      width='50%'
                      border='2px dashed rgba(4, 44, 203, 0.48)'
                      textAlign='center'
                    >
                      <Text
                        color='#001B69'
                        fontSize='1.2rem'
                        fontFamily='Poppins'
                      >
                        Clara3
                      </Text>
                    </Box>
                    <Button
                      width='50%'
                      onClick={() => {
                        copyCoupon()
                      }}
                      variant='link'
                      color={accentColor}
                    >
                      <BiCopy />
                      {dictionary.CARDS.copy_coupon}
                    </Button>
                  </Stack>
                </Box>
                <Box>
                  <HStack bg='#DFECFF' p='2'>
                    <Box>
                      <AiFillInfoCircle />
                    </Box>
                    <Text>
                      {`${
                        skin === 'INVEX'
                          ? dictionary.CARDS.redirectTooltipOneInvex
                          : dictionary.CARDS.redirectTooltipOne
                      }
                      ${
                        skin.charAt(0).toUpperCase() +
                        skin.slice(1).toLowerCase()
                      }
                      ${dictionary.CARDS.redirectTooltipTwo}`}
                      <br />
                      {dictionary.CARDS.check_here} <br />
                      <Link
                        href='https://messages.uber.com/public/messages/53feca88-37a4-4fef-aa25-6c3b27bc3342'
                        target='_blank'
                        fontWeight='500'
                      >
                        {dictionary.CARDS.terms_conditions}
                      </Link>
                    </Text>
                  </HStack>
                </Box>
                <Stack my={3} justifyContent='space-between' direction='row'>
                  <Button
                    color={skin === 'ALBO' ? '#F8644F' : accentColor}
                    width='50%'
                    border={`2px solid ${skin === 'ALBO' ? '#F8644F' : accentColor}`}
                    borderRadius='2px'
                    variant='outline'
                    onClick={handleOverlay}
                  >
                    {dictionary.CARDS.cancel}
                  </Button>
                  <Button
                    color='white'
                    width='50%'
                    borderRadius='2px'
                    bg='#4962E3'
                    onClick={() =>
                      openPageNewTab(
                        'https://auth.uber.com/v2/?breeze_local_zone=dca23&next_url=https%3A%2F%2Fwww.ubereats.com%2Flogin-redirect%2F%3Fapp_clip%3Dfalse%26campaign%3Dsignin_universal_link%26guest_mode%3Dfalse%26marketing_vistor_id%3D1cb858b0-0172-47a5-a168-099e37457cb4%26redirect%3D%252Fmx%253Futm_source%253DAdWords_Brand%2526utm_campaign%253DCM2216943-search-google-brand_113_-99_MX-National_e_web_acq_cpc_es_T1_Generic_BM_uber%252520eats_kwd-111378724137_635624805553_144538982358_b_c%2526campaign_id%253D18953283538%2526adg_id%253D144538982358%2526fi_id%253D%2526match%253Db%2526net%253Dg%2526dev%253Dc%2526dev_m%253D%2526ad_id%253D635624805553%2526cre%253D635624805553%2526kwid%253Dkwd-111378724137%2526kw%253Duber%252520eats%2526placement%253D%2526tar%253D.%2526gclsrc%253Daw.ds%2526gclid%253DCj0KCQjw4NujBhC5ARIsAF4Iv6e47df25ln0ifGuXV8UZLDx2VDjulz_3g5VO9XGgC3lYWKbGkRk18IaAuA_EALw_wcB&state=AVgBD9YG0j-r-hpsU_cqFbNb-Kk8erE2DEyuCt2ANzk%3D&x-uber-did=dfe40c49-9126-4222-8465-5660281e5b13'
                      )
                    }
                  >
                    {dictionary.CARDS.continue}
                  </Button>
                </Stack>
              </ModalBody>
            </ModalContent>
          </Modal>
        )
      default:
        break
    }
  }

  const showBottomSheet = () => {
    return (
      <Drawer
        bg='brand.bg'
        onClose={handleOverlay}
        isOpen={isOverlay}
        size='md'
        placement='bottom'
      >
        <DrawerOverlay
          bg='white.300'
          backdropFilter={
            skin === '' || skin === 'REWORTH'
              ? 'saturate(180%) blur(5px)'
              : skin === 'INVEX'
              ? 'saturate(80%) blur(2px)'
              : skin === 'UNIQ'
              ? 'saturate(60%) blur(2px)'
              : skin === 'COPPEL'
              ? 'saturate(80%) blur(2px)'
              : skin === 'CLARA'
              ? 'saturate(80%) blur(2px)'
              : skin === 'FINSUS'
              ? 'saturate(80%) blur(2px)'
              : skin === 'LIVERPOOL'
              ? 'saturate(60%) blur(2px)'
              : skin === 'SUBURBIA'
              ? 'saturate(60%) blur(2px)'
              : skin === 'ALBO'
                  ? 'saturate(80%) blur(2px)'
              : null
          }
        />
        <DrawerContent bg='brand.bg' borderTopRadius='8px'>
          <DrawerHeader
            bg='brand.bg'
            bgImage={
              skin === '' || skin === 'REWORTH'
                ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                : null
            }
            bgColor={
              skin === '' || skin === 'REWORTH' ? null : 'brand.modalBackground'
            }
            borderRadius='8px'
          >
            <DrawerCloseButton color='#001B69' />
          </DrawerHeader>
          <DrawerBody
            bg='brand.bg'
            bgImage={
              skin === '' || skin === 'REWORTH'
                ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                : null
            }
            bgColor={
              skin === '' || skin === 'REWORTH' ? null : 'brand.modalBackground'
            }
            p='0rem 2rem 2rem 2rem'
          >
            {handleTermsAndConditions(selectedBusiness)}

            {currentWeb !== 'https://www.' && (
              <div>
                <Heading
                  color={skin === 'FINSUS' ? '#23223F' : 'brand.primary'}
                  fontSize={['18px', '18px', '18px', '18px']}
                  fontFamily={fontFamily}
                  fontWeight='500'
                  mt='24px'
                >
                  Enlaces de interés
                </Heading>
                <SocialList
                  fontFamily={fontFamily}
                  currentSocial={currentSocial}
                  currentWeb={currentWeb}
                />
              </div>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    )
  }
  return contextService.width <= 610 ? showBottomSheet() : showModal(modalType)
}



export default SocialMedia
